// extracted by mini-css-extract-plugin
module.exports = {"container":"shipping_container__3oTFL","text":"shipping_text__1jb3u","image":"shipping_image__37eQy"};